var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country"},[(_vm.country.iso)?_c('div',{staticClass:"country-flag",attrs:{"alt":_vm.country.iso,"title":_vm.country.name}},[_vm._v(" "+_vm._s(_vm.flag)+" "+_vm._s(_vm.country.code)+" ")]):_vm._e(),_c('div',{staticClass:"country-label"},[_vm._v(_vm._s(_vm.country?.name || ""))])])
}
var staticRenderFns = []

export { render, staticRenderFns }